import React from 'react'
import { IIconProps } from 'Interfaces'

export function InformationIcon(props: IIconProps) {
    return (
        <svg width={props.width ?? 9} height={props.height ?? 24} viewBox="0 0 9 24" fill="none">
            <path d="M0.25 9.91293C0.25 9.33663 0.717181 8.86945 1.29348 8.86945H5.29348C5.86977 8.86945 6.33696 9.33663 6.33696 9.91293C6.33696 10.4892 5.86978 10.9564 5.29348 10.9564H1.29348C0.717182 10.9564 0.25 10.4892 0.25 9.91293Z" fill={props.color ?? "currentColor"}/>
            <path d="M0.25 22.9564C0.25 22.3801 0.717181 21.913 1.29348 21.913H7.20652C7.78282 21.913 8.25 22.3801 8.25 22.9564C8.25 23.5327 7.78282 23.9999 7.20652 23.9999H1.29348C0.717182 23.9999 0.25 23.5327 0.25 22.9564Z" fill={props.color ?? "currentColor"}/>
            <path d="M2.16299 9.91297L6.33696 9.91293L6.33691 21.913H2.16299V9.91297Z" fill={props.color ?? "currentColor"}/>
            <path d="M7.38057 3.04348C7.38057 4.72435 6.01795 6.08696 4.33709 6.08696C2.65622 6.08696 1.29361 4.72435 1.29361 3.04348C1.29361 1.36261 2.65622 0 4.33709 0C6.01795 0 7.38057 1.36261 7.38057 3.04348Z" fill={props.color ?? "currentColor"}/>
        </svg>        
    )
}
